import request from '@/utils/request'
import qs from 'qs'

export function getRoomTransactionBooking(data) {
  return request({
    url: '/cashier-service/v1/room-transaction/booking',
    method: 'post',
    data: data
  })
}

export function getRoutingList(id) {
  return request({
    url: `/cashier-service/v1/routing/${id}`,
    method: 'get'
  })
}

export function searchFolioApi(params) {
  return request({
    url: '/cashier-service/v1/routing/folios',
    method: 'get',
    params: params
  })
}

export function deleteRouting(data) {
  return request({
    url: '/cashier-service/v1/routing',
    method: 'delete',
    data
  })
}

export function transferTransactionApi(data) {
  return request({
    url: '/cashier-service/v1/room-transaction/transfer',
    method: 'post',
    data: data
  })
}

export function addRoomTransaction(data) {
  return request({
    url: '/cashier-service/v1/room-transaction/payment-transaction',
    method: 'post',
    data: data
  })
}

export function searchFolioAdvanceApi(data) {
  return request({
    url: '/cashier-service/v1/routing/folios-advance',
    method: 'post',
    data: data
  })
}

export function postRouting(data) {
  return request({
    url: '/cashier-service/v1/routing',
    method: 'post',
    data: data
  })
}

export function updateRouting(data) {
  return request({
    url: `/cashier-service/v1/routing/${data.id}`,
    method: 'put',
    data: data
  })
}

export function addRoomCharge(params) {
  return request({
    url: '/cashier-service/v1/room-transaction/room-charge',
    method: 'post',
    params: params
  })
}

export function addMultiRoomTransaction(data, params) {
  return request({
    url: '/cashier-service/v1/room-transaction/multi',
    method: 'post',
    params: params,
    data: data
  })
}

export function getTranPageById(params) {
  return request({
    url: `/cashier-service/v1/room-transaction/transfer/${params.id}`,
    method: 'get'
  })
}

export function getTransactionConfig(params) {
  return request({
    url: '/config-service/v1/account/transaction-config',
    method: 'get',
    params: params
  })
}

export function getTransactionByPage(params) {
  return request({
    url: `/cashier-service/v1/room-transaction/booking/${params.id}`,
    method: 'get',
    params: params
  })
}

export function cancelTransaction(params) {
  return request({
    url: `/cashier-service/v1/room-transaction/cancel/${params.id}`,
    method: 'post',
    params: params
  })
}

export function checkoutCustomer(data) {
  return request({
    url: '/cashier-service/v1/room-transaction/checkout',
    method: 'put',
    data: data
  })
}

export function cardRoomCheckoutApi() {
  return request({
    url: '/card-service/v1/card-room/check-out',
    method: 'put'
  })
}

export function cancelCheckoutCustomer(id) {
  return request({
    url: `/cashier-service/v1/room-transaction/checkout/cancel/${id}`,
    method: 'put'
  })
}

export function splitTransaction(params) {
  return request({
    url: `/cashier-service/v1/room-transaction/split/${params.id}`,
    method: 'post',
    params: params
  })
}

export function getComments(params) {
  return request({
    url: '/cashier-service/v1/room-comment/list',
    method: 'get',
    params: params
  })
}

export function getWarningList(params) {
  return request({
    url: '/cashier-service/v1/room-warning/list',
    method: 'get',
    params: params
  })
}

export function deleteWarningsApi(data) {
  return request({
    url: '/cashier-service/v1/room-warning',
    method: 'delete',
    data: data
  })
}

export function updateWarningApi(data) {
  return request({
    url: '/cashier-service/v1/room-warning',
    method: 'put',
    data: data
  })
}

export function getMessages(params) {
  return request({
    url: '/cashier-service/v1/room-message/list',
    method: 'get',
    params: params
  })
}

export function getMissions(params) {
  return request({
    url: '/booking-service/v1/missions/list-by-sub-booking-id',
    method: 'get',
    params: params
  })
  // return []
}

export function sendMessageApi(data) {
  return request({
    url: `/cashier-service/v1/room-message/${data}/send`,
    method: 'put'
  })
}

export function addForm(url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}

export function handleRow(url, params) {
  return request({
    url: url,
    method: 'get',
    params: params
  })
}

export function handleCancelRow(url) {
  return request({
    url: url,
    method: 'get'
  })
}

export function cancelCompleteMissionApi(id) {
  return request({
    url: `/booking-service/v1/missions/${id}/complete-cancel`,
    method: 'patch'
  })
}

export function completeMissionApi(id, data) {
  return request({
    url: `/booking-service/v1/missions/${id}/complete`,
    method: 'patch',
    data: data
  })
}

export function getMoneyPaymentApi(params) {
  return request({
    url: '/cashier-service/v1/room-transaction/money-payment',
    method: 'get',
    params: params,
    paramsSerializer: query => qs.stringify(query, { arrayFormat: 'repeat' })
  })
}

export function getDebtAccountsApi(params) {
  return request({
    url: '/cashier-service/v1/room-transaction/debt-account',
    method: 'get',
    params: params
  })
}

export function getMoneyRefundApi(params) {
  return request({
    url: '/cashier-service/v1/room-transaction/money-refund',
    method: 'get',
    params: params
  })
}

export function submitRefundFormApi(data) {
  return request({
    url: '/cashier-service/v1/room-transaction/refund',
    method: 'post',
    data: data
  })
}

export function submitEditTransactionApi(id, data) {
  return request({
    url: `/cashier-service/v1/room-transaction/${id}`,
    method: 'put',
    data: data
  })
}

export function getEarlyCheckinOptionsApi(params) {
  return request({
    url: '/config-service/v1/early-late-check/early-late-check',
    method: 'get',
    params: params
  })
}

export function submitEarlyCheckinFormApi(data) {
  return request({
    url: '/cashier-service/v1/room-transaction/service-transaction',
    method: 'post',
    data: data
  })
}

export function updateEarlyCheckinFormApi(params, data) {
  return request({
    url: '/cashier-service/v1/room-transaction/service-transaction',
    method: 'put',
    params: params,
    data: data
  })
}

export function getBreakfastInfoApi(params) {
  return request({
    url: '/config-service/v1/breakfast-code/transaction',
    method: 'get',
    params: params
  })
}

export function undoCommentApi(id) {
  return request({
    url: `/cashier-service/v1/room-comment/${id}/undone`,
    method: 'get'
  })
}

export function onUpdateApi(data) {
  return request({
    url: `/cashier-service/v1/room-comment/${data.id}/see`,
    method: 'put',
    data: data
  })
}

export function onUpdateMessageApi(data) {
  return request({
    url: `/cashier-service/v1/room-message/${data.id}/see`,
    method: 'put',
    data: data
  })
}

export function cancelMissionApi(id, data = {}) {
  return request({
    url: '/booking-service/v1/missions/' + id + '/cancel',
    method: 'patch',
    data
  })
}

export function submitCancelMessageApi(id, params) {
  return request({
    url: '/cashier-service/v1/room-message/' + id + '/cancel',
    method: 'put',
    params: params
  })
}

export function checkoutGroup(id) {
  return request({
    url: `/cashier-service/v1/room-transaction/checkout-by-master/${id}`,
    method: 'put'
  })
}

export function getBookingNoteApi(id) {
  return request({
    url: `/booking-service/v1/booking/update-note/${id}`,
    method: 'get'
  })
}

export function updateBookingNoteApi(payload) {
  return request({
    url: '/booking-service/v1/booking/update-note',
    method: 'put',
    data: payload
  })
}
